import * as React from 'react';
import { useGroundingMenuItem_unstable } from './useGroundingMenuItem';
import { renderGroundingMenuItem_unstable } from './renderGroundingMenuItem';
import { useGroundingMenuItemStyles_unstable } from './useGroundingMenuItemStyles.styles';
import type { GroundingMenuItemProps } from './GroundingMenuItem.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenuItem component - TODO: add more docs
export const GroundingMenuItem: ForwardRefComponent<GroundingMenuItemProps> = React.forwardRef((props, ref) => {
  const state = useGroundingMenuItem_unstable(props, ref);

  useGroundingMenuItemStyles_unstable(state);
  return renderGroundingMenuItem_unstable(state);
});

GroundingMenuItem.displayName = 'GroundingMenuItem';
